// extracted by mini-css-extract-plugin
module.exports = {"internal_loader":"StopHere_internal_loader__1WIST","recalculation_loader_text":"StopHere_recalculation_loader_text__xra63","loader_text":"StopHere_loader_text__388bB"};